import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="max-w-xl mx-auto px-5 pt-24 pb-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-12 h-12 text-[#EA580C] mx-auto" />
      <h1 className="font-heading font-black text-3xl text-[#0B1B3A] mt-6">{t("payment.cancelled")}</h1>
      <p className="text-sm text-[#475569] mt-3">{t("payment.cancelledNote")}</p>
      <Link data-testid="payment-cancel-back" to="/academy" className="btn-blue mt-8 inline-flex">{t("academy.backToCatalog")}</Link>
    </div>
  );
}
